<template>
  <v-menu
    left offset-y
    origin="center center" nudge-top="30px" transition="scale-transition">
    <!-- <v-btn
      flat icon dark
      style="margin-right:-13px !important;"
      class="ma-0 pa-0 ml-0" slot="activator" color="secondary"
      @click.stop>
      <v-icon>more_vert</v-icon>
    </v-btn> -->
    <v-list dense>
      <v-list-tile class="hidden-lg-and-up">
        <v-icon class="mr-2" color="secondary" @click="$emit('execute-task')">play_circle_filled</v-icon>Run Task
      </v-list-tile>
      <v-list-tile class="hidden-lg-and-up" @click="$emit('view-history')">
        <v-icon class="mr-2" color="secondary">history</v-icon>Run History
      </v-list-tile>
      <v-list-tile
        v-if="!task.templated"
        color="error" @click="$emit('delete-task')">
        <v-icon class="mr-2" color="error">delete</v-icon>
        Delete Task
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "CaseTaskActionMenu",
  props: { task: { type: Object, required: true } }
}
</script>
